import EnderecoEditar from './EnderecoEditar';

export default EnderecoEditar;